<template>
    <div><!-- 訂單查詢 -->
        <SearchBar :searchType="searchType" @doOrderSearch="doOrderSearchEvent"/>
        <CCard>
            <CCardBody>
                <div class="table-container">
                    <vue-bootstrap4-table ref="orderSearchBs4Table" class="" 
                        :rows="orderSearchObj.rows" 
                        :columns="columns" 
                        @on-change-query="onChangeQuery"
                        :total-rows="orderSearchObj.totalCount"
                        :config="config" :classes="classes" >
                        <template v-if="isTw" slot="empty-results">
                            查無結果
                        </template>
                        <template v-if="isTw" slot="pagination-info" slot-scope="props">
                            {{paginationInfoTwText(props)}}
                        </template>
                        <template slot="func" slot-scope="props">
                            <button class="btn btn-sm btn-success mr-2" @click="detail(props.row.proid)">{{btnText(props.row)}}</button>
                        </template>
                    </vue-bootstrap4-table>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import SearchBar from './SearchBar';
import Report from './Report'
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
export default {
    components: {
        SearchBar,
        Report,
    },
    mixins: [orderMixin],
    data() {
        return {     
            searchType: 'Order',
            columns: [                
              { label: this.i18n("DocumentQueryTable.FactoryType"), name: "factoryName",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.VendorCode"), name: "lifnr",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Vendor"), name: "cusAbbreviation",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderNo"), name: "bsart_ebeln",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.DocumentVersion"), name: "zzebver",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderDate"), name: "aedat",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderViewed"), name: "isViewTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderConfirm"), name: "confirmTimeTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Purchaser"), name: "ekgrpTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Function"), name: "func"}
          ],
        }
    },
    props : {
    },
    watch: {
      lang: function() {
        this.columns = [                
            { label: this.i18n("DocumentQueryTable.FactoryType"), name: "factoryName",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.VendorCode"), name: "lifnr",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Vendor"), name: "cusAbbreviation",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderNo"), name: "bsart_ebeln",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.DocumentVersion"), name: "zzebver",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderDate"), name: "aedat",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderViewed"), name: "isViewTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.OrderConfirm"), name: "confirmTimeTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Purchaser"), name: "ekgrpTxt",row_text_alignment: "text-left"},
              { label: this.i18n("DocumentQueryTable.Function"), name: "func"}
        ]
      }
    },
    methods: {        
        doOrderSearchEvent (orderQueryParam){             
            if(this.$refs.orderSearchBs4Table){
                this.$refs.orderSearchBs4Table.page = 1
            }            
            this.doOrderSearch(orderQueryParam ,true);
        },
        detail(id) { // 詳細資訊
            sessionStorage.setItem('orderId', id);
            this.$router.push('report');            
        },
        btnText (item){
            if(this.isMember){
               if(!item.confirmTime){
                   return this.i18n('Buttons.ChangeOrderInfo');
               }
            }
            return this.i18n('Buttons.DetailInfo');
        }
    },
    computed: {        
        ...mapGetters(["lang"])
    },
    mounted() {        
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}
</style>

